import React from 'react';
import { logE } from '../Util/Util';
import t from '../Translation/Translation';
import { Row, Col, Button } from 'react-bootstrap';
import Robot from '../../images/robot.png';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
  
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }
  
    componentDidCatch(error, errorInfo) {
      // You can also log the error to an error reporting service
      //logErrorToMyService(error, errorInfo);
      logE(error, errorInfo);
    }

    refreshPage() {
        window.location.reload(false);
    }
  
    render() {
      if (this.state.hasError) {
        return (
            <div>
                <Row className="text-center main_text_color mt-3">
                    <Col>
                        <h1>{t('went_wrong')}</h1>
                    </Col>
                </Row>
                <Row className="text-center main_text_color mt-3">
                    <Col>
                        <h1>{t('reload_continue')}</h1>
                    </Col>
                </Row>
                <Row className="main_text_color mt-3">
                    <Col md="6" className='d-flex'>
                        <img src={Robot} className='h-50 cd-end'/>
                    </Col>
                    <Col md="6">
                        <Button className='mb-1' onClick={() => this.refreshPage()}>{t('click_reload')}</Button>
                    </Col>
                </Row>
            </div>
        );
      }
  
      return this.props.children; 
    }
}